import TsaPersonRealNameInfoVerify from '@/components/personRealNameInfoVerify/index.vue'
let $vm
const plugin = {
  install (vue, pluginOptions = {}) {
    const PersonRealNameInfoVerify = vue.extend(TsaPersonRealNameInfoVerify)
    if (!$vm) {
      $vm = new PersonRealNameInfoVerify({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const personRealNameInfoVerify = {
      show (options = {}) {
        $vm.show = true
        Object.keys(options).map(key => {
          $vm[key] = options[key]
        })
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaPersonRealNameInfoVerify) {
      vue.prototype.$TsaPersonRealNameInfoVerify = personRealNameInfoVerify
    }
  }
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/personRealNameInfoVerify/index.js